"use strict";
var sidebar_controller_1 = require("./sidebar.controller");
var templateUrl = require("./sidebar.html");
exports.sidebar = {
    templateUrl: templateUrl,
    controller: sidebar_controller_1.SidebarController,
    controllerAs: "vm",
    bindToController: true,
    scope: {}
};



/** WEBPACK FOOTER **
 ** ./app/sidebar/sidebar.ts
 **/